/**
 * SlideHeader - Compound component for slide title + optional subtitle.
 * Standardises the header pattern across all non-hero slides.
 */

import React from 'react';
import styled from 'styled-components';
import { spacing } from '@config/spacing';
import { SlideTitle, SlideSubtitle } from './slide-primitives.styles';

const HeaderWrapper = styled.div`
  text-align: center;
  flex-shrink: 0;
  margin-bottom: ${spacing.md};
`;

const HeaderSubtitle = styled(SlideSubtitle)`
  margin-top: ${spacing.sm};
`;

interface SlideHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
}

export const SlideHeader: React.FC<SlideHeaderProps> = ({ title, subtitle }) => (
  <HeaderWrapper>
    <SlideTitle>{title}</SlideTitle>
    {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
  </HeaderWrapper>
);
